import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';
import { injectTopbar } from '@utils/injectTopbar';

/**
 * Injects `content` into the shell top bar while the calling component is
 * mounted, and clears it on unmount. Content is read via a ref so a re-render
 * with a new element identity does not re-fire the injection.
 */
const useTopbar = (content: ReactNode): void => {
	const contentRef = useRef(content);
	contentRef.current = content;

	useEffect(() => {
		injectTopbar(contentRef.current);

		return () => injectTopbar(<></>);
	}, []);
};

export default useTopbar;
